"use client";

import * as React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const Sun = createSVGIcon(
  <>
    <circle cx="12" cy="12" r="7.25" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M12 5.333V0M12 24v-5.333M18.667 12H24M0 12h5.333M16.714 7.286l3.771-3.771M3.515 20.485l3.771-3.77M16.714 16.714l3.771 3.771M3.515 3.515l3.771 3.77"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </>,
  "Sun",
  { viewBox: "0 0 24 24", fill: "none" }
);
